exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement-container .title{overflow:hidden;position:relative;border-bottom:1px dashed #ddd}.agreement-container .title>h4{height:28px;line-height:28px;text-align:center;color:#2d8cf0;font-size:16px}.agreement-container .title>.date{font-size:12px;color:#666;float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50711daa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/comn/UserManualShow.vue
// module id = 1763
// module chunks = 1